import React, { useState, useEffect } from 'react';

import Typist from 'react-typist';

import '../style.css';

function TypedText() {
  const [count, setCount] = useState(1);

  useEffect(() => {
    // document.title = `You clicked ${count} times`;
    console.log(`Count: ${count}`);
    setCount(1);
  }, [count]);

  return (
    <div className="pt-5 h-100 type-text align-content-center row">
      <div className="col-12 align-self-center">
        <p className="typing d-none d-lg-block display-1 font-weight-bold position-relative text-white">
          We make small business digital & IT stuff...
        </p>

        <p className="h3 d-md-block d-sm-block d-lg-none font-weight-bold position-relative text-white">
          We make small business digital & IT stuff, simple...
        </p>

        {count ? (
          <Typist avgTypingDelay={50} onTypingDone={() => setCount(0)}>
            <div className="row h-100 pt-5">
              <div className="col-12">
                <p className="typing d-none d-lg-block display-1 position-relative font-weight-bold text-white">
                  simple :-)
                </p>
              </div>
              <Typist.Backspace count={30} delay={1800} />
            </div>
          </Typist>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}

export default TypedText;
